import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Es digital o físico?',
  a: 'Es 100% digital. Recibirás acceso inmediato a todo el material en formato PDF de alta calidad, listo para descargar y usar en tu celular o imprimir.'
}, {
  q: '¿Sirve para mi país?',
  a: '¡Sí! El sistema es aplicable en cualquier entorno clínico y protocolos internacionales de enfermería.'
}, {
  q: '¿Cuándo accedo?',
  a: 'Inmediatamente después de tu pago, recibirás un correo electrónico con tus datos de acceso para descargar todo el contenido.'
}, {
  q: '¿Y si no me gusta?',
  a: 'Tenés garantía total de 7 días. Si sentís que el material no es para ti, nos envías un correo y te devolvemos el 100% de tu dinero sin hacer preguntas.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="bg-brand-dark py-5 px-5" data-id="element-100">
      <div className="max-w-xl mx-auto" data-id="element-101">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-102">
          ❓ Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-103">
          {faqs.map((faq, idx) => <div key={idx} className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden" data-id="element-104">
              <button className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-gray-800/50 focus:outline-none transition-colors" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-105">
                <span className="font-bold text-white text-sm pr-4" data-id="element-106">
                  {faq.q}
                </span>
                {openIdx === idx ? <ChevronUp className="text-brand-yellow flex-shrink-0" size={18} data-id="element-107" /> : <ChevronDown className="text-gray-600 flex-shrink-0" size={18} data-id="element-108" />}
              </button>
              {openIdx === idx && <div className="px-5 pb-4 text-sm text-gray-400 leading-relaxed border-t border-gray-800" data-id="element-109">
                  <div className="pt-3" data-id="element-110">{faq.a}</div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}